import { BaseFetch } from "../main-model"
export default class ReportProcurementPlanModel extends BaseFetch {
    getReporProcurementPlanBy = (data) =>
    this.authFetch({
      url: "report-procurement-plan/getReporProcurementPlanBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportProcurementPlanYear = (data) =>
    this.authFetch({
      url: "report-procurement-plan/getReportProcurementPlanYear",
      method: "POST",
      body: JSON.stringify(data),
    })

}
